<span class="section-title"><slot name="title" /></span>
<div class="section-body">
    <slot name="body" />
</div>
<slot />

<style>
    .section-title {
        margin-top: 1rem;
        display: block;
        font-size: 1.1rem;
        font-weight: 400;
        padding-bottom: 0.3rem;
        border-bottom: 1px solid #7f8c8d;
        text-transform: uppercase;
    }
    .section-body {
        padding-top: 0.6rem;
        font-size: 1rem;
        font-weight: 200;
        line-height: 2rem;
    }
</style>
